export default defineNuxtPlugin((nuxtApp) => {
    const router = useRouter();

    router.onError((error) => {
        if (
            /Failed to fetch dynamically imported module/.test(error.message) ||
            /Importing a module script failed/.test(error.message)
        ) {
            if (!process.client) return;

            const key = 'nuxt-reload-chunk-error';
            const lastReload = sessionStorage.getItem(key);
            const now = Date.now();

            // Prevent infinite reload loop (limit to 1 reload every 10 seconds)
            if (lastReload && now - parseInt(lastReload) < 10000) {
                console.error('Reload loop detected due to chunk load error, stopping reload.');
                return;
            }

            sessionStorage.setItem(key, now.toString());
            window.location.reload();
        }
    });
});
